export const projectStatusClassMap = {
    ACTIVE: 'bg-soft-success text-success',
    SUSPENDED: 'bg-soft-warning text-warning',
    INACTIVE: 'bg-soft-danger text-danger',
};

export const projectSearchFieldOptions = [
    { value: 'code', label: 'Código' },
    { value: 'name', label: 'Proyecto' },
];

export const projectStatusOptions = [
    { value: 'ALL', label: 'Todos' },
    { value: 'ACTIVE', label: 'Activo' },
    { value: 'SUSPENDED', label: 'Suspendido' },
    { value: 'INACTIVE', label: 'Inactivo' },
];

export const projectSearchFieldLabelMap = {
    code: 'Código',
    name: 'Proyecto',
};

export const formatProjectDate = (isoDate) => {
    if (!isoDate) return '-';

    const date = new Date(isoDate);
    if (Number.isNaN(date.getTime())) return '-';

    return date.toLocaleDateString('es-MX', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    });
};

export const mapProjectForList = (project) => ({
    ...project,
    customerId: typeof project.customer === 'object'
        ? (project.customer?._id || '')
        : (project.customer || ''),
    customerName: typeof project.customer === 'object'
        ? (project.customer?.name || project.customer?.code || '-')
        : (project.customerName || '-'),
});

export const getProjectStatusSummary = (projects) => {
    const rows = Array.isArray(projects) ? projects : [];

    return rows.reduce((accumulator, project) => {
        const status = project?.status || 'INACTIVE';
        return {
            ...accumulator,
            [status]: (accumulator[status] || 0) + 1,
        };
    }, {
        ACTIVE: 0,
        SUSPENDED: 0,
        INACTIVE: 0,
    });
};
